/**
 * @param {object} props
 * @param {string} props.stroke
 * @param {string} [props.className]
 * @returns {React.JSX.Element}
 */
export function Line({ stroke, className }) {
  return (
    <svg width="22" height="6" viewBox="0 0 22 6" fill="none">
      <path
        d="M3 3.30078H19"
        stroke={stroke}
        strokeWidth="5"
        strokeLinecap="round"
        strokeLinejoin="round"
        className={className}
      />
    </svg>
  );
}
